// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3vUDf","options":"AnswerScale_options__272Gd","selected":"AnswerScale_selected__3YZom"};